<template>
  <tr
    class="hover:bg-gray-100 transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm"
    :class="
      {
        'bg-gray-50 border-gray-100': depth <= 1,
        'bg-gray-200 border-gray-300': depth === 2,
        'bg-gray-300 border-gray-400': depth === 3,
        'bg-gray-400 border-gray-500': depth >= 4
      }
    "
  >
    <td
      class="py-3 text-left"
    >
      <div
        class="flex items-center space-x-2"
        :style="{ paddingLeft: `${(depth * 20) + 16}px` }"
      >
        <span
          class="font-semibold text-gray-900"
        >{{ $props.packageTradeItem.billItem }}</span>

        <span
          v-if="wbsCode"
          class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded"
        >
          {{ wbsCode.code }}
        </span>

        <ProvisionalSumBadge
          v-if="tradeItem.is_provisional_sum"
        />

        <p class="w-60 text-gray-700">
          {{ tradeItem.name }}
        </p>
      </div>
    </td>

    <td
      class="pr-3"
      :title="showBudgetCommentTooltip ? varianceComment.body : ''"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showBudgetCommentButton"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          :aria-label="varianceComment ? $t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.editComment') : $t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.addComment')"
          @click.stop="editBudgetComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <button
          v-else-if="!!varianceComment?.body"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          @click.stop="showBudgetcomment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ $tcc(packageTradeItem.value) }}
        </div>
      </div>
    </td>

    <td
      v-if="!falsey(lumpSumCost?.current_claim) && canEditClaim && !typingClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-green-200/50"
      @click="typeClaim"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.removeClaim')"
          @click.stop.capture="removeClaim"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>

        <span class="ml-2">
          {{ !falsey(lumpSumCost?.current_claim) ? $tcc(lumpSumCost.current_claim) : '' }}
        </span>
      </div>
    </td>

    <td
      v-else-if="canEditClaim"
      class="bg-green-200/50"
    >
      <div class="">
        <AppCurrencyInput
          ref="claimInput"
          v-model.number="costForm.form.current_claim"
          name="current_claim"
          type="number"
          min="1"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-green-200/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.currentClaim') + ': ' + (!falsey(lumpSumCost?.current_claim) ? $tcc(lumpSumCost.current_claim) : '')"
    >
      {{ !falsey(lumpSumCost?.current_claim) ? $tcc(lumpSumCost.current_claim) : '' }}
    </td>

    <template v-if="liteMode">
      <td
        v-if="!falsey(lumpSumCost?.current_certified) && !typingCertified && canEditCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.currentCertified') + ': ' + (!falsey(lumpSumCost?.current_certified) ? $tcc(lumpSumCost.current_certified) : '')"
        @click="typeCertified"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.editCertified')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(lumpSumCost?.current_certified) ? $tcc(lumpSumCost.current_certified) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.currentCertified') + ': ' + $t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.editCertified')"
      >
        <div class="">
          <AppCurrencyInput
            ref="certifiedInput"
            v-model.number="costForm.form.current_certified"
            name="current_certified"
            type="number"
            min="1"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="resetTypingCertified"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.currentCertified') + ': ' + (!falsey(lumpSumCost?.current_certified) ? $tcc(lumpSumCost.current_certified) : '')"
      >
        {{ !falsey(lumpSumCost?.current_certified) ? $tcc(lumpSumCost.current_certified) : '' }}
      </td>
    </template>

    <template v-else>
      <td
        v-if="!falsey(lumpSumCost?.current_certified) && !typingCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-green-200/50"
        @click="typeCertified"
      >
        <div class="group flex items-center justify-end">
          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(lumpSumCost?.current_certified) ? $tcc(lumpSumCost.current_certified) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified && !falsey(lumpSumCost?.current_claim)"
        class="bg-green-200/50"
      >
        <div class="">
          <AppInput
            ref="certifiedInput"
            v-model.number="costForm.form.current_certified"
            name="current_certified"
            type="number"
            min="0"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="stopTypingCertified"
            @keyup.esc="typingCertified = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-green-200/50"
      >
        {{ !falsey(lumpSumCost?.current_certified) ? $tcc(lumpSumCost.current_certified) : '' }}
      </td>
    </template>

    <td
      class="group bg-green-200/50"
      :class="{ 'text-red-600': hasVariance && variance !== 0 }"
      :title="hasVariance && variance !== 0 && varianceComment?.body ? varianceComment.body : ''"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showCommentButton"
          type="button"
          class="btn-icon group-hover:visible btn-icon-default invisible mr-1 shrink-0"
          aria-label="Edit variance comment"
          @click.stop="editVarianceComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ hasVariance ? $tcc(variance) : '' }}
        </div>
      </div>
    </td>

    <td class="bg-green-200/50">
      {{ $tcc(packageTradeItem.previous(claim)) }}
    </td>

    <td class="bg-green-200/50 pr-3">
      {{ $tcc(packageTradeItem.previous(claim) + (lumpSumCost?.current_certified || 0)) }}
    </td>

    <td
      v-if="showPercentages && !falsey(lumpSumCost?.current_claim) && canEditClaim && !typingClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-blue-100/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.claimPercentage') + ': ' + (!falsey(lumpSumCost?.current_claim) ? `${$tn((lumpSumCost.current_claim / packageTradeItem.value) * 100)}%` : '')"
      @click="typeClaimPercent"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.removeClaim')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.editClaim')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(lumpSumCost?.current_claim) ? `${$tn((lumpSumCost.current_claim / packageTradeItem.value) * 100)}%` : '' }}
      </div>
    </td>

    <td
      v-else-if="showPercentages && canEditClaim"
      class="bg-blue-100/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.claimPercentage') + ': ' + $t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.editClaim')"
    >
      <div class="">
        <AppInput
          ref="claimPercentInput"
          v-model.number="currentClaimPercent"
          name="current_claim_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.claimPercentage') + ': ' + (!falsey(lumpSumCost?.current_claim) ? `${$tn((lumpSumCost.current_claim / packageTradeItem.value) * 100)}%` : '')"
    >
      {{ !falsey(lumpSumCost?.current_claim) ? `${$tn((lumpSumCost.current_claim / packageTradeItem.value) * 100)}%` : '' }}
    </td>

    <td
      v-else
      class="bg-blue-100/50"
    />

    <template v-if="showPercentages && liteMode">
      <td
        v-if="!falsey(lumpSumCost?.current_certified) && !typingCertified && canEditCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-blue-100/50"
        @click="typeCertifiedPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.TradeRowItem.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(lumpSumCost?.current_certified) ? $tp((lumpSumCost.current_certified / packageTradeItem.value) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified"
        class="bg-blue-100/50"
      >
        <div class="">
          <AppInput
            ref="certifiedPercentInput"
            v-model.number="currentCertifiedPercent"
            name="current_certified_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="resetTypingCertified"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-blue-100/50"
      >
        {{ !falsey(lumpSumCost?.current_certified) ? $tp((lumpSumCost.current_certified / packageTradeItem.value) * 100) : '' }}
      </td>
    </template>

    <template v-else-if="showPercentages">
      <td
        v-if="lumpSumCost?.current_certified && !typingCertified && canEditCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-blue-100/50"
        @click="typeCertifiedPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(lumpSumCost?.current_certified) ? $tp((lumpSumCost.current_certified / packageTradeItem.value) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified && lumpSumCost"
        class="bg-blue-100/50"
      >
        <div class="">
          <AppInput
            ref="certifiedPercentInput"
            v-model.number="currentCertifiedPercent"
            name="current_certified_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="resetTypingCertified"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-blue-100/50"
      >
        {{ !falsey(lumpSumCost?.current_certified) ? $tp((lumpSumCost.current_certified / packageTradeItem.value) * 100) : '' }}
      </td>
    </template>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.previousPercentage') + ': ' + $tp((previousAmount / packageTradeItem.value) * 100)"
    >
      {{ $tp((previousAmount / packageTradeItem.value) * 100) }}
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50 pr-3"
      :aria-label="$t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.accessibility.cumulativePercentage') + ': ' + $tp(((previousAmount + (lumpSumCost?.current_certified || 0)) / packageTradeItem.value) * 100)"
    >
      {{ $tp(((previousAmount + (lumpSumCost?.current_certified || 0)) / packageTradeItem.value) * 100) }}
    </td>

    <td
      class="pr-3"
    >
      {{ $tcc(costToComplete) }}
    </td>

    <td
      class="bg-orange-200/30 relative z-10"
    >
      <span v-if="showForecasts">{{ $tcc(packageTradeItem.baseline_forecast_amount || 0) }}</span>
    </td>

    <td
      v-if="showForecasts && !typingActualForecast && canEditForecast"
      :class="{ 'cursor-pointer': canEditForecast }"
      class="group bg-orange-200/30 relative z-10 pr-3"
      @click="typeActualForecast"
    >
      <div class=" flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="'Edit Current Forecast'"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>

        <span class="ml-2">
          <p>{{ $tcc(getActualForecastValue()) }}</p>

          <p
            v-if="packageTradeItem.previousActualForecastForClaim(claim) !== 0"
            class="text-xs"
            :class="[packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
          >
            {{ $tcc(packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim)) }} m-1
          </p>
        </span>
      </div>
    </td>

    <td
      v-else-if="showForecasts && canEditForecast"
      class="bg-orange-200/30 relative z-10 pr-3"
    >
      <div class="">
        <AppCurrencyInput
          ref="actualForecastInput"
          v-model.number="actualForecastForm.form.actual_forecast_amount"
          name="forecast_amount"
          type="number"
          min="0"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingActualForecast"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingActualForecast = false"
        />

        <p
          v-if="packageTradeItem.previousActualForecastForClaim(claim) !== 0"
          class="text-xs"
          :class="[packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
        >
          {{ $tcc(packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim)) }} m-1
        </p>
      </div>
    </td>

    <td
      v-else-if="showForecasts"
      class="bg-orange-200/30 relative z-10 pr-3"
    >
      <p>
        {{ $tcc(getActualForecastValue()) }}
      </p>

      <p
        v-if="packageTradeItem.previousActualForecastForClaim(claim) !== 0"
        class="text-xs"
        :class="[packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
      >
        {{ $tcc(packageTradeItem.actualForecastForClaim(claim) - packageTradeItem.previousActualForecastForClaim(claim)) }} m-1
      </p>
    </td>
  </tr>
</template>

<script setup lang="ts">
import ProvisionalSumBadge from '@/components/shared/ProvisionalSumBadge.vue';
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianNumber, falsey, roundDecimals, tcc } from '@/helpers';
import { t } from '@/i18n';
import Claim, { ClaimStatus } from '@/models/Claim';
import Package from '@/models/Package';
import PackageTradeItem from '@/models/PackageTradeItem';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { useCommentsStore } from '@/store/comments';
import { useLumpSumCostsStore } from '@/store/lumpSumCosts';
import { usePackageTradeItemsStore } from '@/store/packageTradeItems';
import { useProjectsStore } from '@/store/projects';
import { useWbsCodesStore } from '@/store/wbsCodes';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, useTemplateRef, watch } from 'vue';
import { toast } from 'vue3-toastify';

const props = withDefaults(
  defineProps<{
    trade?: Trade;
    claim: Claim;
    tradeItem: TradeItem;
    projectId: string;
    canEditCertified: boolean;
    packageTradeItem: PackageTradeItem;
    liteMode?: boolean;
    canEditClaim: boolean;
    showPercentages?: boolean;
    showForecasts?: boolean;
    depth?: number;
  }>(),
  {
    liteMode: false,
    depth: 0,
  },
);

const lumpSumCostsStore = useLumpSumCostsStore();
const projectsStore = useProjectsStore();
const wbsCodesStore = useWbsCodesStore();

const lumpSumCost = computed(() => {
  return lumpSumCostsStore.models
    .where('trade_item_id', props.tradeItem.id)
    .where('claim_id', props.claim.id)
    .with('comments')
    .first();
});

const wbsCode = computed(() => {
  return wbsCodesStore.models.find(props.packageTradeItem.wbs_code_id);
});

const varianceComment = computed(() => {
  return lumpSumCost.value?.comments?.[0];
});

const isOptionalComment = computed(() => {
  if(!lumpSumCost.value) {
    return false;
  }

  const claim = lumpSumCost.value.current_claim;
  const certified = lumpSumCost.value.current_certified;

  if(falsey(claim) || falsey(certified)) {
    return false;
  }

  return claim === certified;
});

const variance = computed(() => {
  return lumpSumCost.value?.current_claim - lumpSumCost.value?.current_certified;
});

const hasVariance = computed(() => {
  return !falsey(lumpSumCost.value?.current_claim) && !falsey(lumpSumCost.value?.current_certified);
});

const typingCertified = ref(falsey(lumpSumCost.value?.current_certified));
const typingClaim = ref(falsey(lumpSumCost.value?.current_claim));
const claimInput = ref();
const claimPercentInput = ref();
const certifiedInput = ref();
const certifiedPercentInput = ref();

const costForm = useFormData({
  id: undefined,
  comment_trade: false,
  current_certified: undefined,
  current_claim: undefined,
  comment: undefined,
});

const previousAmount = computed(() => {
  return props.packageTradeItem.previous(props.claim);
});

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_claim / props.packageTradeItem.value) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.packageTradeItem.value * 100) === 100) {
      costForm.form.current_claim = props.packageTradeItem.value - previousAmount.value;

      return;
    }

    costForm.form.current_claim = roundDecimals((value / 100) * props.packageTradeItem.value);
  },
});

const currentCertifiedPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_certified / props.packageTradeItem.value) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.packageTradeItem.value * 100) === 100) {
      costForm.form.current_certified = props.packageTradeItem.value - previousAmount.value;

      return;
    }

    costForm.form.current_certified = roundDecimals((value / 100) * props.packageTradeItem.value);
  },
});

const typeClaim = () => {
  if(props.canEditClaim) {
    typingClaim.value = true;

    if(lumpSumCost.value) {
      costForm.form.current_claim = lumpSumCost.value.current_claim;
    }

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(props.canEditClaim) {
    typingClaim.value = true;

    if(lumpSumCost.value) {
      costForm.form.current_claim = lumpSumCost.value.current_claim;
    }

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const typeCertified = () => {
  if(props.canEditCertified) {
    typingCertified.value = true;

    if(lumpSumCost.value) {
      costForm.form.current_certified = lumpSumCost.value.current_certified;
    }

    nextTick(() => {
      certifiedInput.value?.focusInput();
    });
  }
};

const typeCertifiedPercent = () => {
  if(props.canEditCertified) {
    typingCertified.value = true;

    if(lumpSumCost.value) {
      costForm.form.current_certified = lumpSumCost.value.current_certified;
    }

    nextTick(() => {
      certifiedPercentInput.value?.focusInput();
    });
  }
};

const canEditForecast = computed(() => {
  return (props.liteMode && props.claim.status === ClaimStatus.draft) || props.claim.status !== ClaimStatus.certified;
});

watch(lumpSumCost, (newValue) => {
  if(newValue) {
    costForm.setData(newValue);
  }
}, { immediate: true });

const storeSingleCertifiedAction = useStoreApiAction(lumpSumCostsStore.saveCertifiedCost);
const storeLumpSumCostAction = useStoreApiAction(lumpSumCostsStore.create);
const updateLumpSumCostAction = useStoreApiAction(lumpSumCostsStore.update);
const updateCommentAction = useStoreApiAction(lumpSumCostsStore.updateComment);
const storeCommentAction = useStoreApiAction(lumpSumCostsStore.storeComment);
const deleteCommentAction = useStoreApiAction(lumpSumCostsStore.deleteComment);
const deleteLumpSumCostAction = useStoreApiAction(lumpSumCostsStore.delete);

const deleteCost = () => {
  deleteLumpSumCostAction.request(lumpSumCost.value.id).then(() => {
    costForm.form.current_certified = undefined;
    costForm.form.current_claim = undefined;
    typingCertified.value = true;
    typingClaim.value = true;
  }).catch((_error) => {
    Swal.fire({
      icon: 'error',
      title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.somethingWentWrong'),
    });
  });
};

const removeCertified = () => {
  if(falsey(lumpSumCost.value.current_claim)) {
    deleteCost();
  } else {
    updateLumpSumCostAction.request(lumpSumCost.value.id, { current_certified: undefined })
      .then((tradeItemCost) => {
        console.log(tradeItemCost);
        typingCertified.value = true;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_certified = lumpSumCost.value.current_certified;
      });
  }
};

const updateLiteCertified = async () => {
  if(
    (falsey(costForm.form.current_certified) && !lumpSumCost.value) ||
    !typingCertified.value
  ) {
    return;
  }

  if(roundDecimals(costForm.form.current_certified + previousAmount.value) > props.packageTradeItem.value) {
    const budgetDifference = roundDecimals(costForm.form.current_certified + previousAmount.value) -
      props.packageTradeItem.value;

    const allowOverBudget = projectsStore.project?.head_contract_settings?.allow_certified_over_budget;

    if(allowOverBudget) {
      const result = await Swal.fire({
        icon: 'warning',
        title: 'Total exceeds budget.',
        text:
          `The total amount is greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tcc(budgetDifference)
          }. Press OK to save the amount as is.`,

        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      });

      if(!result.isConfirmed) {
        return;
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid amount.',
        text:
          `The certified amount cannot be greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tcc(budgetDifference)
          }`,
      });

      costForm.resetData(['current_certified']);

      return;
    }
  }

  // if user clears certified and claim is also cleared, delete the cost
  if(falsey(costForm.form.current_certified) && lumpSumCost.value && falsey(lumpSumCost.value.current_claim)) {
    deleteLumpSumCostAction.request(lumpSumCost.value.id).then(() => {
      typingCertified.value = true;
    }).catch((_error) => {
      typingCertified.value = false;
    });
  } else if(lumpSumCost.value) {
    // if the cost exists
    costForm.resetData(['comment']);
    let commentSet = true;

    // if current certified is set and incoming new claim != current certified, require comment
    if(
      !falsey(lumpSumCost.value.current_claim) &&
      costForm.form.current_certified !== lumpSumCost.value.current_claim
    ) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: 'Reason for Adjustment',
        text: 'Please provide a reason for the variance between the claim and certified amounts.',
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    }

    if(commentSet) {
      updateLumpSumCostAction.request(lumpSumCost.value.id, {
        current_certified: costForm.form.current_certified,
        comment: costForm.form.comment,
      })
        .then((_lumpSumCost) => {
          if(falsey(lumpSumCost.value?.current_certified)) {
            typingCertified.value = true;
          } else {
            typingCertified.value = false;
          }
        }).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidData'),
              text: error.data.message,
            });
          }

          costForm.form.current_certified = lumpSumCost.value.current_certified;

          typingCertified.value = true;
        });
    }
  } else {
    storeLumpSumCostAction.request(props.claim.id, props.tradeItem.id, costForm.form).then((lumpSumCost) => {
      typingCertified.value = false;
    }).catch((error) => {
      console.log(error);

      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
          text: error.data.message,
        });
      }

      typingCertified.value = true;
    });
  }
};

const updateCertified = async () => {
  if(costForm.form.current_certified > props.packageTradeItem.value) {
    const budgetDifference = costForm.form.current_certified - props.packageTradeItem.value;
    const allowOverBudget = projectsStore.project?.head_contract_settings?.allow_certified_over_budget;

    if(allowOverBudget) {
      const result = await Swal.fire({
        icon: 'warning',
        title: 'Total exceeds budget.',
        text:
          `The total amount is greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tcc(budgetDifference)
          }`,

        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      });

      if(!result.isConfirmed) {
        return;
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid amount.',
        text:
          `The certified amount cannot be greater than the budget. It is recommended that you create a variation to capture the remaining overflow ${
            tcc(budgetDifference)
          }`,
      });

      costForm.resetData(['current_certified']);

      return;
    }
  }

  if(costForm.form.current_certified !== lumpSumCost.value?.current_certified) {
    let commentSet = true;

    if(costForm.form.current_certified !== lumpSumCost.value?.current_claim) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: 'Reason for Adjustment',
        text: 'Please provide a reason for the variance between the claim and certified amounts.',
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    } else {
      costForm.form.comment = undefined;
    }

    if(commentSet) {
      // Save the certified amount
      storeSingleCertifiedAction.request(props.projectId, props.claim.id, lumpSumCost.value.id, costForm.form)
        .then(
          (_lumpSumCost) => {
            // console.log('Certified amount updated:', lumpSumCost);
          },
        ).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: 'Invalid data.',
              text: error.data.message,
            });
          }

          costForm.form.current_certified = lumpSumCost.value?.current_certified;
        });
    } else {
      costForm.form.current_certified = lumpSumCost.value?.current_certified;
    }
  }

  typingCertified.value = false;
};

const stopTypingCertified = async () => {
  if(props.liteMode) {
    updateLiteCertified();
  } else {
    updateCertified();
  }
};

const stopTypingClaim = async () => {
  // if claim not set and the cost does not exist, then don't continue
  if(
    (falsey(costForm.form.current_claim) && !lumpSumCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  // if both have been cleared out, delete the cost
  if(falsey(costForm.form.current_claim) && lumpSumCost.value && falsey(lumpSumCost.value.current_certified)) {
    deleteLumpSumCostAction.request(lumpSumCost.value.id).then(() => {
      typingClaim.value = true;
    }).catch((_error) => {
      typingClaim.value = false;
    });
  } else if(lumpSumCost.value) {
    // updating existing cost current_claim
    costForm.resetData(['comment']);
    let commentSet = true;

    // if current certified is set and incoming new claim != current certified, require comment
    if(
      !falsey(lumpSumCost.value.current_certified) &&
      costForm.form.current_claim !== lumpSumCost.value.current_certified
    ) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: 'Reason for Adjustment',
        text: 'Please provide a reason for the variance between the claim and certified amounts.',
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    }

    if(commentSet) {
      updateLumpSumCostAction.request(lumpSumCost.value.id, {
        current_claim: costForm.form.current_claim,
        comment: costForm.form.comment,
      })
        .then((_lumpSumCost) => {
          if(falsey(lumpSumCost.value.current_claim)) {
            typingClaim.value = true;
          } else {
            typingClaim.value = false;
          }
        }).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidData'),
              text: error.data.message,
            });
          }

          costForm.form.current_claim = lumpSumCost.value.current_claim;
          typingClaim.value = true;
        });
    }
  } else {
    storeLumpSumCostAction.request(props.claim.id, props.tradeItem.id, costForm.form).then((_lumpSumCost) => {
      typingClaim.value = false;
    }).catch((error) => {
      console.log(error);

      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
          text: error.data.message,
        });
      }

      typingClaim.value = true;
    });
  }
};

const removeClaim = () => {
  if(falsey(lumpSumCost.value.current_certified)) {
    deleteCost();
  } else {
    updateLumpSumCostAction.request(lumpSumCost.value.id, { current_claim: undefined })
      .then((lumpSumCost) => {
        typingClaim.value = true;
        costForm.form.current_claim = lumpSumCost.value.current_claim;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_claim = lumpSumCost.value.current_claim;
      });
  }
};

const resetTypingCertified = () => {
  typingCertified.value = false;
  costForm.form.current_certified = lumpSumCost.value?.current_certified || 0;
};

const packageTradeItemsStore = usePackageTradeItemsStore();
const typingActualForecast = ref(false);

const getActualForecastValue = () => {
  return props.packageTradeItem.actualForecastForClaim(props.claim);
};

const actualForecastForm = useFormData({
  actual_forecast_amount: getActualForecastValue(),
});

const actualForecastInput = useTemplateRef('actualForecastInput');
const updateForecastAmountsAction = useStoreApiAction(packageTradeItemsStore.updateForecastAmounts);

const typeActualForecast = () => {
  if(canEditForecast.value) {
    typingActualForecast.value = true;

    actualForecastForm.setData({
      actual_forecast_amount: getActualForecastValue(),
    });

    nextTick(() => {
      actualForecastInput.value?.focusInput();
    });
  }
};

const stopTypingActualForecast = async () => {
  if(
    (falsey(actualForecastForm.form.actual_forecast_amount) && getActualForecastValue() === 0) ||
    !typingActualForecast.value
  ) {
    typingActualForecast.value = false;
    actualForecastForm.form.actual_forecast_amount = getActualForecastValue();

    return;
  }

  updateForecastAmountsAction.request(props.packageTradeItem.id, {
    actual_forecast_amount: actualForecastForm.form.actual_forecast_amount,
  }).then(() => {
    typingActualForecast.value = false;
  }).catch((error) => {
    if(error.status === 422) {
      Swal.fire({
        icon: 'error',
        title: t('Subcontract.SubcontractorClaimShow.LumpSumTradeRowItem.error.invalidAmount'),
        text: error.data.message,
      });
    }

    actualForecastForm.form.actual_forecast_amount = getActualForecastValue();
    typingActualForecast.value = true;
  });
};

const showCommentButton = computed(() => {
  return hasVariance.value && variance.value !== 0 && !!varianceComment.value && props.canEditCertified;
});

const showBudgetCommentButton = computed(() => {
  return props.canEditCertified &&
    !falsey(lumpSumCost.value) &&
    !falsey(lumpSumCost.value.current_certified) &&
    !falsey(lumpSumCost.value.current_claim);
});

const showBudgetCommentTooltip = computed(() => {
  return !!varianceComment.value?.body && showBudgetCommentButton.value;
});

const showBudgetcomment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: varianceComment.value?.body,
  });
};

const editBudgetComment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: (hasVariance.value && variance.value !== 0) ?
      'Please provide a reason for the variance between the claim and certified amounts.' :
      'Provide an optional comment for the cost.',

    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: varianceComment.value ? 'Update' : 'Save',
    showDenyButton: isOptionalComment.value && !!varianceComment.value,
    denyButtonText: 'Delete',
    denyButtonColor: '#d33',
  }).then((result) => {
    if(result.isDenied && varianceComment.value) {
      deleteCommentAction.request(lumpSumCost.value.id, varianceComment.value.id).then(() => {
        toast.success('Comment deleted');
      });
    } else if(result.isConfirmed && result.value) {
      if(varianceComment.value) {
        updateCommentAction.request(lumpSumCost.value.id, varianceComment.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment updated');
          },
        );
      } else {
        storeCommentAction.request(lumpSumCost.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment saved');
          },
        );
      }
    }
  });
};

const editVarianceComment = () => {
  Swal.fire({
    icon: 'warning',
    title: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentTitle'),
    text: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentText'),
    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: 'Update',
  }).then((result) => {
    if(result.isConfirmed) {
      if(result.value) {
        updateCommentAction.request(lumpSumCost.value.id, varianceComment.value.id, { comment: result.value }).then(
          () => {
            toast.success('Comment updated');
          },
        );
      }
    }
  });
};

const costToComplete = computed(() => {
  return Math.max(
    props.packageTradeItem.value - props.packageTradeItem.previous(props.claim) -
      (lumpSumCost.value?.current_certified || 0),
    0,
  );
});
</script>

<style scoped></style>
